import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { BackendModule } from '@shared/datastore/core';
import { searchMyProjectsBuyerBackend } from './search-my-projects-buyer.backend';
import { searchMyProjectsBuyerReducer } from './search-my-projects-buyer.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(
      'searchMyProjectsBuyer',
      searchMyProjectsBuyerReducer,
    ),
    BackendModule.forFeature(
      'searchMyProjectsBuyer',
      searchMyProjectsBuyerBackend,
    ),
  ],
})
export class DatastoreSearchMyProjectsBuyerModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/search-my-projects-buyer/search-my-projects-buyer.module.ts